import { createSlice } from "@reduxjs/toolkit";
import { fetchWarehouseWiseStock } from "./thunk";

interface WarehouseWiseStockState {
  data: any[];
  totalRecords: number;
  loading: boolean;
  error: string | null;
}

const initialState: WarehouseWiseStockState = {
  data: [],
  totalRecords: 0,
  loading: false,
  error: null,
};

const warehouseWiseStockSlice = createSlice({
  name: "warehouseWiseStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseWiseStock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseWiseStock.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
      })
      .addCase(fetchWarehouseWiseStock.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch warehouse-wise stock";
      });
  },
});

export default warehouseWiseStockSlice.reducer;
